let _ = require('lodash');
// import * as cookies from "./utils/cookies.js";
import * as tailwind from "../../tailwind.js";

export function setAlerts() {

  // let closeBtn = document.getElementById("closeAlert");
  let alerts = document.getElementById("alerts");
  let body = document.body;
  let header = document.getElementById('header');
  let mainContent = document.getElementById('main-content');
  let secondaryNav = document.getElementsByClassName('js-secondary-nav-container');
  let mobileNav = document.getElementsByClassName('js-mobile-nav-container');
  let resetStyles = () => {
    if (header && secondaryNav[0] && mobileNav[0]) {
      header.style.top = 0;
      mainContent.style.paddingTop = 0;
      secondaryNav[0].style.marginTop = 0;
      mobileNav[0].style.marginTop = 0;
    }
  };

  if (body.classList.contains('hasAlert')) {

    // _debouce function on window resize to adjust header positions
    let adjustHeader = () => {
      // if this is responsive screens where the header is fixed...
      if (window.outerWidth < parseInt(tailwind.screens.menu)) {
        if (header && secondaryNav[0] && mobileNav[0]) {
          header.style.top = alerts.offsetHeight + "px";
          mobileNav[0].style.marginTop = (alerts.offsetHeight + mobileNav[0].style.paddingTop) + "px";
          mainContent.style.paddingTop = (alerts.offsetHeight + header.offsetHeight) + "px";
        }
      } else {
        resetStyles();
      }
    };

    window.addEventListener('resize', _.debounce(adjustHeader, 150));
    adjustHeader();

  }

  // if (closeBtn) {
  //   closeBtn.addEventListener("click", function (e) {
  //     e.preventDefault();
  //     let cookieName = e.target.getAttribute('data-cookie');
      
  //     cookies.setCookie(cookieName, "1", 1);

  //     // alerts.style.display = "none";
  //     alerts.remove();
  //     resetStyles();
  //     //console.log("cookie set");
  //   });
  // }
}



// WEBPACK FOOTER //
// ./resources/js/alerts.js